import { createStore, applyMiddleware } from 'redux';

import { createMiddlewareList } from './middlewares';
import { getAppConfig } from './modules/appConfig/utils/appConfigGenerator';
import { rootReducer } from './reducers/rootReducer';

export default (analytics, initialState, apiClient, appConfigParam) => {
  const appConfig = getAppConfig(appConfigParam);
  const middlewareList = createMiddlewareList({
    analytics,
    apiClient,
    appConfig,
  });
  const createStoreWithMiddleware = applyMiddleware(...middlewareList)(
    createStore,
  );
  const store = createStoreWithMiddleware(
    rootReducer,
    initialState,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
  );
  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      // Enable Webpack hot module replacement for reducers
      module.hot.accept('./reducers/rootReducer', () => {
        const nextRootReducer = require('./reducers/rootReducer');
        store.replaceReducer(nextRootReducer);
      });
    }
  }

  return store;
};
